const { createSlice } = require("@reduxjs/toolkit");

const PayBillsSlicer = createSlice({
  name: "GetPayBillsData",
  initialState: {
    customerData: {},
  },
  reducers: {
    getPayBillsData: (state, action) => {
      state.customerData = action.payload;
    },
    resetState: () => initialState,
  },
});
export const { getPayBillsData, resetState } = PayBillsSlicer.actions;
export default PayBillsSlicer.reducer;